// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9ea0b844","835":"41024c0e"}[chunkId] + ".chunk.js";
};